import {RouterLink} from '@angular/router';
import {ReactiveFormsModule} from '@angular/forms';
import {PhoneFormatPipe} from '../misc/pipes/phone-format/phone-format.pipe';

/**
 * Declarables shared by the feature components.
 *
 * Deliberately narrow: with native control flow (`@if`/`@for`) nothing here needs `CommonModule`,
 * no template binds `ngModel`, and `RouterLink` alone covers every router directive in use — so
 * the broad `CommonModule`/`RouterModule`/`FormsModule` entries only cost bundle size. Components
 * that need `NgOptimizedImage` import it themselves.
 */
export const COMMON_IMPORTS = [
	RouterLink,
	ReactiveFormsModule,
	PhoneFormatPipe
] as const;
